import dynamic from 'next/dynamic'
import { LocationVisitsIcon } from 'src/components/insights/icons/location-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/visits-trends.png'

const VisitsTrends = dynamic(() => import('src/components/insights/location-visits/visits-trends'), { ssr: false })

export const VisitsTrendsWidget: InsightBuilderWidget = {
  id: 'visit-and-visitor-trends',
  name: 'Visit Trends',
  component: VisitsTrends,
  type: 'Location Visits',
  icon: LocationVisitsIcon,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
